<div class="card">
  <app-header
    titulo="Provedores"
    descricao="Cadastre a origem ou o destino dos dados que seus processos vão usar">
  </app-header>

  <div class="surface-50 border-1 surface-border border-round p-3 mb-4 line-height-3">
    <strong>Por onde começar?</strong> Crie um provedor para cada banco de dados ou API. Ao criar, informe a primeira conexão e sua credencial.
    Depois, use <strong>Conexões</strong> para adicionar outros ambientes; nas conexões de API, cadastre também as rotas que serão chamadas.
  </div>

  <p-table
    #dt
    [value]="provedores"
    dataKey="id"
    [loading]="loading"
    [globalFilterFields]="['nome', 'descricao', 'tipo']"
    styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines"
    [paginator]="true"
    [rows]="20"
    [rowsPerPageOptions]="[10, 20, 50, 100]"
    [showCurrentPageReport]="true"
    currentPageReportTemplate="Mostrando de {first} até {last} de {totalRecords} registros"
    [scrollable]="true"
    scrollHeight="500px">

    <!-- Caption com ações -->
    <ng-template pTemplate="caption">
      <div class="flex flex-wrap align-items-center justify-content-between gap-2">
        <div class="flex align-items-center">
          <button
            pButton
            pRipple
            label="Novo Provedor"
            icon="pi pi-plus"
            class="p-button-success mr-2"
            (click)="novoProvedor()">
          </button>
          <button
            pButton
            pRipple
            icon="pi pi-filter-slash"
            class="p-button-outlined"
            (click)="limparFiltros()"
            pTooltip="Limpar filtros"
            tooltipPosition="top">
          </button>
        </div>

        <span class="p-input-icon-left">
          <i class="pi pi-search"></i>
          <input
            pInputText
            type="text"
            [(ngModel)]="termoBusca"
            (input)="dt.filterGlobal(termoBusca, 'contains')"
            placeholder="Buscar provedor"
            aria-label="Buscar provedor"
            class="w-full" />
        </span>

        <button
          pButton
          pRipple
          icon="pi pi-refresh"
          class="p-button-outlined"
          (click)="carregarProvedores()"
          [loading]="loading"
          pTooltip="Atualizar"
          tooltipPosition="top">
        </button>
      </div>
    </ng-template>

    <!-- Header -->
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="nome" style="min-width: 200px;">
          Nome
          <p-sortIcon field="nome"></p-sortIcon>
        </th>
        <th pSortableColumn="tipo" style="width: 150px;">
          Tipo
          <p-sortIcon field="tipo"></p-sortIcon>
        </th>
        <th pSortableColumn="descricao" style="min-width: 250px;">
          Descrição
          <p-sortIcon field="descricao"></p-sortIcon>
        </th>
        <th pSortableColumn="dtCriado" style="width: 150px;">
          Data Criação
          <p-sortIcon field="dtCriado"></p-sortIcon>
        </th>
        <th style="width: 240px; text-align: center;">
          Ações
        </th>
      </tr>
    </ng-template>

    <!-- Body -->
    <ng-template pTemplate="body" let-provedor>
      <tr>
        <td>
          <strong>{{ provedor.nome }}</strong>
        </td>
        <td>
          <p-tag
            [value]="getTipoLabel(provedor.tipo)"
            [severity]="getTipoSeverity(provedor.tipo)"
            [icon]="provedor.tipo === TipoProvedor.BASEDADOS ? 'pi pi-database' : 'pi pi-globe'">
          </p-tag>
        </td>
        <td>{{ provedor.descricao }}</td>
        <td>{{ provedor.dtCriado | date: 'dd/MM/yyyy HH:mm' }}</td>
        <td class="text-center">
          <button
            pButton
            pRipple
            icon="pi pi-link"
            label="Conexões"
            class="p-button-info p-button-text mr-1"
            (click)="gerenciarConexoes(provedor)"
            [attr.aria-label]="'Gerenciar conexões de ' + provedor.nome"
            pTooltip="Gerenciar conexões e endpoints"
            tooltipPosition="top">
          </button>
          <button
            pButton
            pRipple
            icon="pi pi-pencil"
            class="p-button-rounded p-button-warning p-button-text mr-1"
            (click)="editarProvedor(provedor)"
            [attr.aria-label]="'Editar ' + provedor.nome"
            pTooltip="Editar"
            tooltipPosition="top">
          </button>
          <button
            pButton
            pRipple
            icon="pi pi-trash"
            class="p-button-rounded p-button-danger p-button-text"
            (click)="deletarProvedor(provedor)"
            [attr.aria-label]="'Excluir ' + provedor.nome"
            pTooltip="Excluir"
            tooltipPosition="top">
          </button>
        </td>
      </tr>
    </ng-template>

    <!-- Empty message -->
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="5" class="text-center">
          <div class="text-gray-500 py-5">
            <i class="pi pi-info-circle text-4xl mb-3"></i>
            <p class="text-xl mb-2">Nenhum provedor cadastrado</p>
            <p class="text-sm mb-3">Comece criando seu primeiro provedor de dados</p>
            <button
              pButton
              pRipple
              label="Criar Primeiro Provedor"
              icon="pi pi-plus"
              class="p-button-success"
              (click)="novoProvedor()">
            </button>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>

  <!-- Confirm Dialog -->
  <p-confirmDialog [style]="{ width: '450px' }"></p-confirmDialog>
</div>
